// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-9"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M11.9971 21H12H20V5.40018L15.9985 3L11.9985 5.49908L7.99854 3L3.99707 5.40018V21H11.9971Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M16 16V21M8 16V21M16 9.99805H16.0039V10.002H16V9.99805ZM8 9.99805H8.00391V10.002H8V9.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 21H11.9971M12 21H20M12 21V5.5L11.9985 5.49908M11.9971 21H3.99707M11.9971 21V5.5L11.9985 5.49908M11.9985 5.49908L7.99854 3L2.99707 6M11.9985 5.49908L15.9985 3L21 6M19.9985 21V5.9M3.99854 21V5.9","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-9')
export default class City9Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-9',
    }
  }
}
